'use client';

import { useFormContext } from '@/components/features/Form/FormContext';
import { css } from '@onbeam/business-styled-system/css';
import { token } from '@onbeam/business-styled-system/tokens';
import { Button } from '@onbeam/business-ui';
import { useBreakpoint } from '@onbeam/utils';
import {
  APPLICATION_STORAGE_KEY,
  ApplicationFormSchema,
} from '../ApplicationForm.utils';
import { useRouter } from 'next/navigation';

export const ApplicationFormExitButton = () => {
  const router = useRouter();
  const {
    form: { getValues },
  } = useFormContext<ApplicationFormSchema>();
  const isMobile = useBreakpoint({ max: token('breakpoints.md') });

  const handleExit = () => {
    const values = getValues();
    localStorage.setItem(APPLICATION_STORAGE_KEY, JSON.stringify(values));
    router.push('/applications');
  };

  return (
    <Button
      onClick={handleExit}
      variant="outline"
      size={isMobile ? 'sm' : 'md'}
      className={css({
        whiteSpace: 'nowrap',
      })}
    >
      Save & exit
    </Button>
  );
};
